// Shared urgency counter logic - deterministic based on day of month
// Both main site and calculator page use this so numbers always match

export const getTerminalSpotsLeft = () => {
  const now = new Date();
  const day = now.getDate();
  const totalDays = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  
  // Start at 12, decrease throughout month, minimum 2
  const progress = day / totalDays;
  const spots = Math.max(2, Math.round(12 - (progress * 10)));
  
  return spots;
};
